/**
 * Bestelregels met een protocol als bundel bij elkaar zetten, voor het beheer en de pakbon: zo pakt
 * Sarah het als set in. Puur; de volgorde blijft die van de bestelling (een bundel staat op de plek
 * van zijn eerste regel). Getest in core/rules/orderBundles.test.ts.
 */
export type LineGroup<T> = { routineId: string | null; lines: T[] }

export function groupByBundle<T>(lines: readonly T[], bundleOf: (line: T) => string | null | undefined): LineGroup<T>[] {
  const groups: LineGroup<T>[] = []
  const byRoutine = new Map<string, LineGroup<T>>()
  for (const line of lines) {
    const id = bundleOf(line) || null
    if (!id) {
      groups.push({ routineId: null, lines: [line] })
      continue
    }
    const existing = byRoutine.get(id)
    if (existing) {
      existing.lines.push(line)
      continue
    }
    const group = { routineId: id, lines: [line] }
    byRoutine.set(id, group)
    groups.push(group)
  }
  return groups
}

/** Een webshopregel hoort bij een bundel als hij `bundle` én `routineId` heeft. */
export const requestBundleOf = (l: { routineId?: string; bundle?: boolean }) => (l.bundle && l.routineId ? l.routineId : null)
